import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './motion-makers-admin-v3';
import './versalien.css';   // Tanuki immer in Versalien

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
